export const GET_USER_SUCCESS = "user/get/success";
export const GET_USER_ERROR = "user/get/error";
export const GET_USER_LOADING = "user/get/loading";
